<div class="privacy-container">
  <div *ngIf="_withText">Privacy:</div>
  <div class="p-cont" *ngIf="_code == 'P01'">
    <mat-icon matChipAvatar matTooltip="Public">public</mat-icon>
    <!-- <div class="p-text">Public</div> -->
  </div>
  <div class="p-cont" *ngIf="_code == 'P02'">
    <mat-icon matChipAvatar matTooltip="Followers">group</mat-icon>
    <!-- <div class="p-text">Followers</div> -->
  </div>
  <div class="p-cont" *ngIf="_code == 'P03'">
    <mat-icon matChipAvatar matTooltip="Only Me">lock</mat-icon>
    <!-- <div class="p-text">Only Me</div> -->
  </div>
</div>
